import { getBondFormKindConfig } from "../../shared/bondFormConfig";
import useBondFormBase, { createBondKindLogic } from "../../shared/hooks/useBondFormBase";

const config = getBondFormKindConfig("trustee");

export default function useTrusteeBondForm() {
  return useBondFormBase({
    config,
    logContext: "useTrusteeBondForm",
    useBondKindLogic: createBondKindLogic(config),
  });
}
